/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Gotoform01/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Gotoform01({
  children,
  viewPath = "/DesignSystem/Svgs/Gotoform01",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 1062,
  height = 794.4,
  fill = "#E1F2EA",
  fill2 = "#C9EDE0",
  fill4 = "#EDEDED",
  fill5 = "#00BC70",
  fill6 = "#D1D1D1",
  fill8 = "#3ACC6C",
  fill12 = "#F7F7F7",
  fill17 = "#FFF",
  fill22 = "#00A663",
  fill24 = "#E3787D",
  fill25 = "#212121",
  fill26 = "#383838",
  fill27 = "#E0E0E0",
  fill28 = "#FBBEBE",
  fill34 = "#C4686D",
  fill35 = "#2B2B2B",
  fill36 = "#3D3D3D",
  fill38 = "#E6E8EC"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Gotoform01.Svg"
  data-view-path={viewPath}
 viewBox="0 0 1062 794.4"
 style={{'--as-1-Z1gdbuN': alignSelf,'--mt-2-Z1gdbuN': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1gdbuN': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1gdbuN': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1gdbuN': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1gdbuN': opacity,'--w-7-Z1gdbuN': typeof width === 'number' ? `${width}px` : width,'--h-8-Z1gdbuN': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Gotoform01.SvgPath"
  data-view-path={viewPath}
 d="M411.1 106.3c-177 30.5-291.9 246-328.1 299.4-17 25.1-36.8 49-49.9 75.7s-19.2 57.2-7.7 84.5c11.4 27 38.5 47.2 67.9 61.5 59.7 29 130 37.2 198.6 41.9 151.8 10.4 304.5 5.9 456.7 1.4 56.3-1.7 112.9-3.3 168.3-12.1 30.8-4.8 62.6-12.5 84.9-31.1 28.4-23.5 35.4-63.4 16.4-92.9-31.9-49.5-120-61.8-142.3-114.9-12.3-29.2.3-61.8 18.2-88.9 38.2-58.2 87-212.7-58.5-238.2-180-31.5-247.5-16.8-424.5 13.7z"
 style={{'--f-9-Z1gdbuN': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="Gotoform01.SvgPath:1"
  data-view-path={viewPath}
 d="M492.8 292h372.9v289.8H492.8z"
 style={{'--f-9-Z1gdbuN': fill2}}
 className={`views-block ${styles.SvgPath1}`}
/>
<path
  data-testid="Gotoform01.SvgPath:2"
  data-view-path={viewPath}
 d="M666 312.6h349.7v254.8H666z"
 style={{'--f-9-Z1gdbuN': fill2}}
 className={`views-block ${styles.SvgPath2}`}
/>
<path
  data-testid="Gotoform01.SvgPath:3"
  data-view-path={viewPath}
 d="M772 298h259.5v259.5H772z"
 style={{'--f-9-Z1gdbuN': fill4}}
 className={`views-block ${styles.SvgPath3}`}
/>
<path
  data-testid="Gotoform01.SvgPath:4"
  data-view-path={viewPath}
 d="M901.7 215.4c14.6 0 26.4 11.8 26.4 26.4s-11.8 26.4-26.4 26.4-26.4-11.8-26.4-26.4c0-7 2.8-13.7 7.7-18.6 5-5.1 11.7-7.8 18.7-7.8m0-4.1c-16.9 0-30.5 13.7-30.5 30.5s13.7 30.5 30.5 30.5c16.9 0 30.5-13.7 30.5-30.5 0-16.9-13.7-30.5-30.5-30.5.1 0 0 0 0 0z"
 style={{'--f-9-Z1gdbuN': fill5}}
 className={`views-block ${styles.SvgPath4}`}
/>
<path
  data-testid="Gotoform01.SvgPath:5"
  data-view-path={viewPath}
 d="M818.7 344.1h96.5v10.7h-96.5z"
 style={{'--f-9-Z1gdbuN': fill6}}
 className={`views-block ${styles.SvgPath5}`}
/>
<path
  data-testid="Gotoform01.SvgPath:6"
  data-view-path={viewPath}
 d="M904.3 232.8h-11.2v-4.6h17.5v3.8l-7.5 7.6c1.7 0 3.2.3 4.4 1 1.3.7 2.2 1.6 2.9 2.8s1 2.6 1 4.1c0 2.9-.9 5.2-2.7 6.8-1.8 1.6-4.3 2.4-7.6 2.4-1.9 0-3.7-.3-5.3-1-1.6-.7-3.1-1.6-4.4-2.8l2.5-3.6c1 .8 2.2 1.5 3.4 2s2.5.8 3.7.8c1.6 0 2.9-.4 3.8-1.3.9-.8 1.3-2 1.3-3.5s-.5-2.6-1.4-3.4c-.9-.8-2.2-1.2-4-1.2-.4 0-.9 0-1.4.1-.6.1-1.1.2-1.6.3l-1.2-2.7 7.8-7.6z"
 style={{'--f-9-Z1gdbuN': fill5}}
 className={`views-block ${styles.SvgPath6}`}
/>
<path
  data-testid="Gotoform01.SvgPath:7"
  data-view-path={viewPath}
 d="M627.5 367.4l-1.2-1.3c-.1-.1-.1-.1-.2-.1s-.1 0-.2.1l-8.5 8.6-3.1-3.1c-.1 0-.1-.1-.2-.1s-.1 0-.2.1l-1.2 1.2c-.1.1-.1.3 0 .4l3.9 3.9c.2.2.5.4.8.4s.6-.2.8-.4l9.3-9.4c.1 0 .1-.2 0-.3z"
 style={{'--f-9-Z1gdbuN': fill8}}
 className={`views-block ${styles.SvgPath7}`}
/>
<path
  data-testid="Gotoform01.SvgPath:8"
  data-view-path={viewPath}
 d="M620.1 359.2c7 0 12.6 5.6 12.6 12.6s-5.6 12.6-12.6 12.6-12.6-5.6-12.6-12.6c0-3.3 1.3-6.6 3.7-8.9 2.3-2.4 5.5-3.7 8.9-3.7m0-2c-8 0-14.6 6.5-14.6 14.5s6.5 14.6 14.5 14.6 14.6-6.5 14.6-14.5c0-8.1-6.5-14.6-14.5-14.6zM627.5 439.3l-1.2-1.3c-.1-.1-.1-.1-.2-.1s-.1 0-.2.1l-8.5 8.6-3.1-3.1c-.1-.1-.1-.1-.2-.1s-.1 0-.2.1l-1.2 1.2c-.1.1-.1.3 0 .4l3.9 3.9c.2.2.5.4.8.4s.6-.2.8-.4l9.3-9.4c.1 0 .1-.2 0-.3z"
 style={{'--f-9-Z1gdbuN': fill8}}
 className={`views-block ${styles.SvgPath8}`}
/>
<path
  data-testid="Gotoform01.SvgPath:9"
  data-view-path={viewPath}
 d="M620.1 431.2c7 0 12.6 5.6 12.6 12.6s-5.6 12.6-12.6 12.6-12.6-5.6-12.6-12.6c0-3.3 1.3-6.6 3.7-8.9 2.3-2.4 5.5-3.7 8.9-3.7m0-2c-8 0-14.6 6.5-14.6 14.5s6.5 14.6 14.5 14.6 14.6-6.5 14.6-14.5c0-8.1-6.5-14.6-14.5-14.6z"
 style={{'--f-9-Z1gdbuN': fill8}}
 className={`views-block ${styles.SvgPath9}`}
/>
<path
  data-testid="Gotoform01.SvgPath:10"
  data-view-path={viewPath}
 d="M734.5 170.2c18.4 0 33.3 14.8 33.3 33.2s-14.8 33.3-33.2 33.3-33.3-14.8-33.3-33.2c0-8.8 3.5-17.3 9.7-23.6 6.2-6.3 14.7-9.8 23.5-9.7m0-5.2c-21.2 0-38.4 17.2-38.4 38.4s17.2 38.4 38.4 38.4 38.5-17.2 38.5-38.4-17.2-38.4-38.5-38.4z"
 style={{'--f-9-Z1gdbuN': fill5}}
 className={`views-block ${styles.SvgPath10}`}
/>
<path
  data-testid="Gotoform01.SvgPath:11"
  data-view-path={viewPath}
 d="M589.9 280.9h289.2v289.2H589.9z"
 style={{'--f-9-Z1gdbuN': fill12}}
 className={`views-block ${styles.SvgPath11}`}
/>
<path
  data-testid="Gotoform01.SvgPath:12"
  data-view-path={viewPath}
 d="M652.9 342.6h96.5v10.7h-96.5zM652.9 380.4h96.5v10.7h-96.5z"
 style={{'--f-9-Z1gdbuN': fill6}}
 className={`views-block ${styles.SvgPath12}`}
/>
<path
  data-testid="Gotoform01.SvgPath:13"
  data-view-path={viewPath}
 d="M729.2 188.1c1.8-.9 3.7-1.4 5.7-1.4 3.1 0 5.6.8 7.3 2.4 1.8 1.6 2.6 3.8 2.6 6.5 0 1.8-.6 3.6-1.7 5.4-1.1 1.8-2.9 4.1-5.2 6.7l-6 6h13.6v5.1h-21.8v-4.4l6.6-6.7c2.2-2.2 3.8-3.8 4.9-5.1s2.1-2.4 2.8-3.6c.7-1.2 1.1-2.3 1.1-3.3 0-1.1-.4-2.1-1.1-2.8-.8-.7-1.9-1.1-3.4-1.1-1.2 0-2.5.3-3.7 1-1.3.7-2.4 1.6-3.5 2.7l-3-4c1.3-1.2 3-2.5 4.8-3.4z"
 style={{'--f-9-Z1gdbuN': fill5}}
 className={`views-block ${styles.SvgPath13}`}
/>
<g
  data-testid="Gotoform01.SvgGroup"
  data-view-path={viewPath}
 className="views-block"
>
<path
  data-testid="Gotoform01.SvgPath:14"
  data-view-path={viewPath}
 d="M529.3 119.7c24.3 0 43.9 19.7 43.9 44s-19.7 43.9-44 43.9-43.9-19.7-43.9-44c0-11.6 4.6-22.8 12.9-31 8.3-8.3 19.5-12.9 31.1-12.9m0-6.8c-28.1 0-50.8 22.7-50.8 50.8s22.7 50.8 50.8 50.8 50.8-22.7 50.8-50.8c0-28-22.7-50.8-50.8-50.8z"
 style={{'--f-9-Z1gdbuN': fill5}}
 className={`views-block ${styles.SvgPath14}`}
/>
<path
  data-testid="Gotoform01.SvgPath:15"
  data-view-path={viewPath}
 d="M347.2 266.3h357.5v357.5H347.2z"
 style={{'--f-9-Z1gdbuN': fill2}}
 className={`views-block ${styles.SvgPath15}`}
/>
<path
  data-testid="Gotoform01.SvgPath:16"
  data-view-path={viewPath}
 d="M359.2 249.3h357.5v357.5H359.2z"
 style={{'--f-9-Z1gdbuN': fill17}}
 className={`views-block ${styles.SvgPath16}`}
/>
<path
  data-testid="Gotoform01.SvgPath:17"
  data-view-path={viewPath}
 d="M396.6 288.9h282.6v10.7H396.6z"
 style={{'--f-9-Z1gdbuN': fill5}}
 className={`views-block ${styles.SvgPath17}`}
/>
<path
  data-testid="Gotoform01.SvgPath:18"
  data-view-path={viewPath}
 d="M396.6 366.4h179.9v10.7H396.6zM396.6 438.4H586v10.7H396.6zM396.6 474.4h238v10.7h-238z"
 style={{'--f-9-Z1gdbuN': fill6}}
 className={`views-block ${styles.SvgPath18}`}
/>
<path
  data-testid="Gotoform01.SvgPath:19"
  data-view-path={viewPath}
 d="M532.9 145.3v38.9h-7.1v-30.5l-6.2 4.3-3.4-5.3 10.6-7.4h6.1z"
 style={{'--f-9-Z1gdbuN': fill5}}
 className={`views-block ${styles.SvgPath19}`}
/>
</g>
<path
  data-testid="Gotoform01.SvgPath:20"
  data-view-path={viewPath}
 d="M935.7 682.8l19.1-11.3c-2.6-4.4-5.9-8.4-9.8-11.7l-36 11.3 28.3-16.6c-22.3-12.2-50.2-4-62.4 18.2-3.7 6.8-5.7 14.4-5.7 22.1 0 25.4 20.6 26.3 46 26.3s46-.9 46-26.3c0-6.4-1.3-12.8-4-18.7l-21.5 6.7z"
 style={{'--f-9-Z1gdbuN': fill5}}
 className={`views-block ${styles.SvgPath20}`}
/>
<path
  data-testid="Gotoform01.SvgPath:21"
  data-view-path={viewPath}
 d="M940.6 707.5c-2-2-4.3-3.8-6.8-5.3-3.5-2.3-7.1-4.7-11.2-5.5-3.6-.7-7.3-.1-11-.3-6.4-.4-12.4-3.1-16.8-7.7-2.6-2.7-4.7-6-7.8-8.1-3.4-2.2-7.7-2.7-11.7-2.2-1.2.2-2.3.4-3.5.7-1.8 5-2.7 10.3-2.7 15.6 0 25.4 20.6 26.3 46 26.3 12.3 0 23.5-.2 31.8-3.3l-1.4-2.6c-1.3-2.7-2.9-5.3-4.9-7.6z"
 style={{'--f-9-Z1gdbuN': fill22}}
 className={`views-block ${styles.SvgPath21}`}
/>
<g
  data-testid="Gotoform01.SvgGroup:1"
  data-view-path={viewPath}
 className="views-block"
>
<ellipse
  data-testid="Gotoform01.SvgEllipse"
  data-view-path={viewPath}
 cx={243.3}
 cy={721.1}
 rx={85.5}
 ry={12}
 style={{'--f-9-Z1gdbuN': fill}}
 className={`views-block ${styles.SvgEllipse}`}
/>
<circle
  data-testid="Gotoform01.SvgCircle"
  data-view-path={viewPath}
 cx={218.1}
 cy={343.9}
 r={25.7}
 style={{'--f-9-Z1gdbuN': fill24}}
 className={`views-block ${styles.SvgCircle}`}
/>
<path
  data-testid="Gotoform01.SvgPath:22"
  data-view-path={viewPath}
 d="M203.2 543.8c2.7 18.6-.6 37.6-5.6 55.7-.9 3.4-2 6.8-3.7 9.8s-4.2 5.6-6.3 8.5c-4.3 5.9-6.8 12.9-9.2 19.9-6.5 19.2-12 38.7-16.4 58.4-.3.8-.3 1.7 0 2.5.6 1.4 2.5 1.6 4.1 1.6l20.2-.1c.7-1.4-.6-2.9-1.4-4.2-2.9-4.5-.1-10.3 2.4-15 6.2-11.4 10.9-23.4 14.2-35.9 1.4-5.3 2.5-10.7 4.7-15.6 2.7-6 7-11.2 10.4-16.8 4-6.5 6.9-13.7 9.8-20.8 4.1-9.9 8.1-19.9 9.7-30.5 1.5-9.9.8-20.1-.2-30.1.2-1-.6-2-1.6-2.2h-.6l-27.1-1.4c-5.6-.3-6.9-1.5-6.1 4 .7 4.1 2.1 8.1 2.7 12.2z"
 style={{'--f-9-Z1gdbuN': fill25}}
 className={`views-block ${styles.SvgPath22}`}
/>
<path
  data-testid="Gotoform01.SvgPath:23"
  data-view-path={viewPath}
 d="M208.5 498.6c-5.5 7.9-11.3 17-9.4 26.5 1.4 7.2 6.9 12.8 12 18 20.7 20.7 41 43.8 48 72.2 1.8 7.3 2.7 14.9 4.2 22.3 2.8 13.4 7.9 26.3 12.9 39.1l13.5 34c8.6.2 16.4-5 19.5-12.9-1.8-.1-4.1-1.8-5.1-3.3-5.7-8-6.9-18.2-8.4-27.9-1.6-10.7-3.8-21.4-6-32l-9.7-47c-1.1-5.4-2.2-10.9-3.7-16.2-5.6-20.7-16.3-40.2-17.9-61.7-.2-3.1-.4-6.6-2.5-8.9-2.2-2.5-5.9-2.9-9.3-3.1-13.4-1-25-2.3-38.1.9z"
 style={{'--f-9-Z1gdbuN': fill26}}
 className={`views-block ${styles.SvgPath23}`}
/>
<path
  data-testid="Gotoform01.SvgPath:24"
  data-view-path={viewPath}
 d="M172.2 695.6c-1.5-.3-3-.5-4.5-.6-2.9.1-5.6 1.6-7.3 4-.8 1.3-1.5 2.8-2 4.3l-1.9 5.6c-.6 1.6-1.1 3.5-.3 5 .6.9 1.6 1.6 2.6 2 4.7 2.1 10.1 2.2 15.2 2.7 5 .5 9.9 1.4 14.9 2.3 1.7.3 3.4.6 5.1.8 3.8.4 7.7 0 11.5-.3l4-.4c1.3-.1 2.6-.3 3.9-.7 1.3-.4 2.3-1.4 2.9-2.6 1-2.4-1.1-5.3-3.7-5.8-1-.2-2.2-.1-3.2-.2-1.2-.2-2.4-.6-3.5-1-5-2-10.2-4-14.6-7.1-1.2-.9-2.5-2.1-2.4-3.6.1-.6.3-1.3.6-1.9.6-1.5.6-3.3.1-4.8-.2-.7-.7-1.4-1.4-1.4-1.9-.2-1.7 2.5-1.9 3.6-.4 1.4-1.1 1.6-2.4 1.4-4-.4-7.9-.6-11.7-1.3zM285.7 714.9c0 2.8 1 5.5 2.7 7.7.5.7 1.2 1.2 2 1.6 1.1.5 2.4.7 3.6.6 3.4-.1 6.8-.8 10-2 1.1-.5 2.3-.9 3.4-1.3 1.5-.3 3-.5 4.5-.6 5.9-.9 11.2-4.4 16.9-6.1 1.7-.4 3.4-1 5-1.7 2.3-1.1 4.1-2.9 5.9-4.6 1.1-.9 2-2 2.7-3.3 1.1-2 1.1-4.3 1.2-6.5 0-.3 0-.7-.2-1-.2-.2-.4-.4-.6-.5-1.7-.9-3.8-.4-5.7-.1-7 1.2-14.1 1-21.2.8-1.4.2-2.7-.6-3.3-1.9l-2.7-4.3c-.8-1.2-2-2.7-3.4-2.2-1.1.3-1.6 1.7-1.5 2.9 0 1.2.4 2.3.2 3.5-.3 1.3-1.2 2.4-2.3 3-1.1.6-2.3 1.1-3.6 1.4-4 1.1-8.6 2.4-11.7 5.3-2.3 1.9-2.1 6.5-1.9 9.3z"
 style={{'--f-9-Z1gdbuN': fill27}}
 className={`views-block ${styles.SvgPath24}`}
/>
<path
  data-testid="Gotoform01.SvgPath:25"
  data-view-path={viewPath}
 d="M284.3 429.8c1.5-1.2 2.9-2.6 3.9-4.3.9-1.9 1.5-3.9 1.7-5.9l1.1-7.1c.6-3.9 1.4-8.1 4-11.1s7.8-4.1 10.5-1.1c1.2 1.3 1.6 3.1 1.9 4.8 1.7 10.4-1.5 20.9-8.5 28.7-3.2 3.5-7.2 6.3-10.6 9.7-3 2.9-5.6 6.2-8.3 9.3-6.6 7.6-14.2 14.2-22.6 19.8.1-5.3.8-11.1 0-16.4-.6-3.8-2.2-5.9 1.6-8.4 8.6-5.9 17.3-11.2 25.3-18zM211.8 377.2c-.3 3.8-1.9 7.7-5 9.9 9 3.1 17.8 6.6 26.5 10.4-1.7-1.6-2.2-4.1-2.3-6.4-.2-6.1 1.9-12.1 5-17.3.5-.7.8-1.5.8-2.3-.1-1.7-2.1-2.5-3.8-2.9-5.6-1.4-11.4-2.2-17.2-2.5-2.5-.1-5.4-.9-4.9 2.3.6 2.9 1.1 5.8.9 8.8z"
 style={{'--f-9-Z1gdbuN': fill28}}
 className={`views-block ${styles.SvgPath25}`}
/>
<circle
  data-testid="Gotoform01.SvgCircle:1"
  data-view-path={viewPath}
 cx={229.1}
 cy={358.2}
 r={21}
 style={{'--f-9-Z1gdbuN': fill28}}
 className={`views-block ${styles.SvgCircle1}`}
/>
<path
  data-testid="Gotoform01.SvgPath:26"
  data-view-path={viewPath}
 d="M249.9 414.9c-.7-1.6-1.6-3.1-2.7-4.5-3.8-5.5-7.7-10.9-12.6-15.5-3.7-3.3-7.7-6.2-12-8.8-2.3-1.6-4.8-2.8-7.5-3.6-1.6-.4-3.2-.6-4.8-.7l-5.5-.4c-.5-.1-1 0-1.4 0-1.5.4-2.2 2.2-1.8 3.7.3 1.5 1.4 2.7 2.4 3.8.2 11.1-4.7 22.1-5.4 33.2-1.2 19.4 10.7 37.5 11.6 57 .1.9 0 1.8-.3 2.6l-.6 1.2c-.6 1.2-.5 2.6-.6 4-.4 4.8-2.5 9.3-5.9 12.7.9 1.1 2 2 3.3 2.5 2.3 1 5 1.1 7.5 1.8 6.4 1.9 12.9 3.7 19.5 3.3.8-1.8 1.3-3.7 1.5-5.7.9-.6 2 .7 2.2 1.8.1 1.1-.1 2.4.7 3.2.8.8 1.8.7 2.7.5 4-.5 7.9-1.9 11.9-2.8 4-.9 8.2-1.4 12 0 .8-1 .4-2.4-.2-3.5s-1.5-2-1.9-3.2c-.2-.7-.3-1.4-.2-2.1 0-6.1 1.3-12.4.1-18.4-.4-1.8-.9-3.5-1.3-5.3-.7-3.4-.6-7-.5-10.5.1-3.5-.3-7.3-.4-10.9 0-1.5-.1-2.9-.3-4.4-.2-1.5-.7-3-.8-4.6-.4-3.9 1.2-7.8 1-11.8-.4-5.8-7.4-9-9.7-14.6z"
 style={{'--f-9-Z1gdbuN': fill5}}
 className={`views-block ${styles.SvgPath26}`}
/>
<path
  data-testid="Gotoform01.SvgPath:27"
  data-view-path={viewPath}
 d="M202.5 412.1c-5.1 13.5-7.6 27.8-10.1 42l-5.7 33.4c-1.6 9.4-3.3 18.9-3.2 28.5 0 2.7.2 5.4-.5 8-.9 3.4-3.2 6.2-4.9 9.3-3.5 6.3-4.7 13.7-3.3 20.8.6 3 2.2 6.4 5.2 6.7 2.5.3 4.6-1.7 6.1-3.7 3.3-4.7 5-10.3 6.5-15.9 4.8-18.2 8.1-36.7 10-55.4.2-2.4.5-4.7 1-7 .6-2.4 1.4-4.7 2.4-7 2.2-5.5 4.4-10.9 6.6-16.4 5.1-12.6 10.2-25.3 17.2-36.9-6.9-2-14.1-4.3-21-6.3-2.1-.5-4.3-.2-6.3-.1z"
 style={{'--f-9-Z1gdbuN': fill28}}
 className={`views-block ${styles.SvgPath27}`}
/>
<path
  data-testid="Gotoform01.SvgPath:28"
  data-view-path={viewPath}
 d="M214.4 422.4c-4.8-1-9.8-.7-14.8-.8-.7.1-1.4-.1-2-.5-1-.9-.6-2.5-.1-3.7l2.4-5.8c.4-1.2 1-2.3 1.9-3.2 1.2-1.1 2.9-1.3 4.5-1.5 5.2-.6 10.6-.8 15.7.6s9.9 4.6 12.1 9.4c.9 2 1.4 4.5.1 6.3-1.9 2.7-6.1 5.7-9.2 4.2-3.5-1.8-6.4-4.1-10.6-5z"
 style={{'--f-9-Z1gdbuN': fill5}}
 className={`views-block ${styles.SvgPath28}`}
/>
<path
  data-testid="Gotoform01.SvgPath:29"
  data-view-path={viewPath}
 d="M240.1 325.6c-4.2 0-8.2 1.1-11.7 3.4-6.7-6.4-16.4-8.6-25.2-5.9-1.4-8-9-13.3-17-11.9-8 1.4-13.3 9-11.9 17 1.1 6.1 5.9 10.9 12 11.9-4 13.6 3.8 27.9 17.4 31.9 13.6 4 27.9-3.8 31.9-17.4 1.5.3 3.1.5 4.6.5 10.1 0 18.4-6.6 18.4-14.7-.1-8.3-8.4-14.8-18.5-14.8z"
 style={{'--f-9-Z1gdbuN': fill24}}
 className={`views-block ${styles.SvgPath29}`}
/>
<path
  data-testid="Gotoform01.SvgPath:30"
  data-view-path={viewPath}
 d="M243.8 347.6c-1.5 0-3.1-.2-4.6-.5-.7 2.6-1.9 5.1-3.4 7.4 1.4.3 2.9.4 4.3.4 9.5 0 17.2-5.8 18.2-13.1-3.3 3.5-8.6 5.8-14.5 5.8zM214.4 366c-14.2 0-25.7-11.6-25.7-25.8 0-2.5.4-5.1 1.1-7.5-7-1.2-12.1-7.3-12.1-14.5 0-.9.1-1.8.2-2.6-5.5 6-5.1 15.2.8 20.8 2.1 1.9 4.7 3.2 7.4 3.7-4.1 13.6 3.5 27.9 17.1 32.1 13.5 4.1 27.7-3.4 32-16.8-4.8 6.6-12.5 10.6-20.8 10.6z"
 style={{'--f-9-Z1gdbuN': fill34}}
 className={`views-block ${styles.SvgPath30}`}
/>
<path
  data-testid="Gotoform01.SvgPath:31"
  data-view-path={viewPath}
 d="M294.4 430.6s.9.9 1.7.8c1.2-.3 7.6-38.1 7.8-39.3.3-1.6-.8-2.5-2.1-2.7-1.1-.2-7.4 41.2-7.4 41.2z"
 style={{'--f-9-Z1gdbuN': fill35}}
 className={`views-block ${styles.SvgPath31}`}
/>
<path
  data-testid="Gotoform01.SvgPath:32"
  data-view-path={viewPath}
 d="M295.5 388.1l6.7 1.3c.5.2.8 1.6.6 3.1l-7 37.4c-.2 1-.9 1.3-1.4.6l-6.9-7.4c-.5-.5-.8-1.5-.5-2.3l7.2-30.4c.2-1.2.8-2.3 1.3-2.3z"
 style={{'--f-9-Z1gdbuN': fill36}}
 className={`views-block ${styles.SvgPath32}`}
/>
<path
  data-testid="Gotoform01.SvgPath:33"
  data-view-path={viewPath}
 d="M301.7 390.6l-1-.4-.1.3c-.1.8-.5 1.4-.8 1.3l-3.1-.8c-.3-.1-.4-.7-.3-1.5l.1-.3-.9-.1c-.4 0-.8.7-1 1.6l-7 30.1c-.2.6 0 1.3.4 1.7l6.4 6.7c.4.5.8.3 1-.4l6.8-36.1c.1-.9-.1-1.9-.5-2.1z"
 style={{'--f-9-Z1gdbuN': fill5}}
 className={`views-block ${styles.SvgPath33}`}
/>
<path
  data-testid="Gotoform01.SvgPath:34"
  data-view-path={viewPath}
 d="M297.9 389.7l1 .2c.1 0 .1.2.1.4s-.1.3-.2.3l-1-.2c-.1 0-.1-.2-.1-.3.1-.3.2-.4.2-.4zM299.2 390.1c.1-.1.2 0 .2.1 0 .2 0 .4-.1.5-.1.1-.2 0-.2-.1 0-.2 0-.4.1-.5z"
 style={{'--f-9-Z1gdbuN': fill38}}
 className={`views-block ${styles.SvgPath34}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}